import styled from '@emotion/styled/macro';
import * as color from '../../../style/color';

export const PageTitle = styled.span`
  display: inline-block;
  border-left: 2px solid ${color.primary};
  padding: 0px 45px 0 15px;
  font-size: 16px;
  line-height: 1.5;
  margin-right: 8px;
`;

export default PageTitle;
